import * as React from 'react';

const SvgBalanceMini = (props) => (
  <svg
    width={32}
    height={32}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.04 2.667H10.96c-5.04 0-6.293 1.346-6.293 6.72V24.4c0 3.547 1.947 4.387 4.307 1.853l.013-.013c1.093-1.16 2.76-1.067 3.707.2l1.346 1.8c1.08 1.427 2.827 1.427 3.907 0l1.347-1.8c.96-1.28 2.626-1.373 3.72-.2 2.373 2.533 4.306 1.693 4.306-1.853v-15c.014-5.374-1.24-6.72-6.28-6.72Zm-1.04 13h-8c-.546 0-1-.454-1-1 0-.547.454-1 1-1h8c.547 0 1 .453 1 1 0 .546-.453 1-1 1Zm1.334-5.334H10.667c-.547 0-1-.453-1-1 0-.546.453-1 1-1h10.667c.546 0 1 .454 1 1 0 .547-.454 1-1 1Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgBalanceMini;
